define('mailsMailHeaderView',[
  'app',
  'module',
  'backbone',
  'marionette',
  'underscore',
  'settings',
  'dateUtils',
  'moment',
  'mailsMailHeaderLabelsView',
  'emailView',
  'template!mailsMailHeaderView',
  'entities/mails'
], function (
  App,
  Module,
  Backbone,
  Marionette,
  _,
  Settings,
  DateUtils,
  moment,
  LabelsView,
  EmailView,
  Tpl
) {
  'use strict';

  Module.exports = Marionette.LayoutView.extend({
    template: Tpl,
    className: 'mail-header-view',

    ui: {
      subject: '.subject',
      from: '.from',
      to: '.to',
      cc: '.cc',
      date: '.date',
      loader: '.loader-ctn',
      replyButton: '.reply',
      replyAllButton: '.replyAll',
      forwardButton: '.forward',
      customerSecId: '.customerSecId'
    },

    events: {
      'click @ui.replyButton': 'onReply',
      'click @ui.replyAllButton': 'onReplyAll',
      'click @ui.forwardButton': 'onForward'
    },

    regions: {
      labelsRegion: '.labels-region'
    },

    onShow: function () {

      this.renderContent();

      this.labelsView = new LabelsView({
        model: this.model,
        mailSecId: this.options.mailSecId
      });
      this.getRegion('labelsRegion').show(this.labelsView);

    },

    renderContent: function () {

        // Render 'from' recipients
        this.renderRecipients('from');

        // Render 'to' recipients
        this.renderRecipients('to');

        // Render 'cc' recipients
        this.renderRecipients('cc');

      this.ui.subject.html(this.model.get('subject'));

      this.ui.date.html(DateUtils.toMDYHHMMFormat(this.model.get('sentDate')));

      var customerSecId = this.model.get('customerSecId');
      if (customerSecId) {
        this.ui.customerSecId.css('display', 'flex');
        this.ui.customerSecId.attr('href', '#/customers/' + this.model.get('customerSecId') + '/profile');
      }
    },

      // Helper method to render recipient lists
      renderRecipients: function(type) {
          var recipients = this.model.get(type);
          if (recipients && recipients.length > 0) {
              var recipientElements = [];

              _.each(recipients, function (recipient) {
                  var recipientHtml = '';
                  if (recipient.personal) {
                      recipientHtml += '<span class="name">' + recipient.personal + '</span> ';
                  }
                  recipientHtml += '<span class="mail">&lt;' + recipient.address + '&gt;</span>';
                  recipientElements.push(recipientHtml);
              });

              // Set the content with label and joined recipients
              this.ui[type].html(_.i18n('common.' + type) + ': ' + recipientElements.join(', '));

          } else if (type === 'cc') {
              // Hide CC field if empty
              this.ui[type].css('display', 'none');
          }
      },

    // Generalized method to handle email actions
    prepareEmailAction: function(actionType) {
        var from = null;
        if (this.options.parentView && this.options.parentView.options.parentView) {
            _.each(this.options.parentView.options.parentView.options.parentView.options.parentView.menuView.mailsCollection.models,
                function (model) {
                    if (model.get('id') === this.options.mailSecId)
                        from = model.get('value');
            }, this);
        } else
            from = this.model.get('emailAddress').email;
        
        if (!from) return null;
        
        var subject = '';
        var content = '';

        var toAddresses = [];
        var ccAddresses = [];
        var bccAddresses = [];
        if (actionType === 'reply') {
            // Set the original sender as recipient
            if (this.model.get('from') && this.model.get('from').length > 0)
                toAddresses.push(this.model.get('from')[0].address);
        }

        if (actionType === 'replyAll') {          
            // Set the original sender as recipient
            if (this.model.get('from') && this.model.get('from').length > 0)
                toAddresses.push(this.model.get('from')[0].address);

            // Add original recipients to the to field
            if (this.model.get('to') && this.model.get('to').length > 0) {
                _.each(this.model.get('to'), function(recipient) {
                    if (recipient.address !== from) {
                        toAddresses.push(recipient.address);
                    }
                });
            }

            // Add CC recipients to the CC field
            if (this.model.get('cc') && this.model.get('cc').length > 0) {
                _.each(this.model.get('cc'), function(recipient) {
                    if (recipient.address !== from) {
                        ccAddresses.push(recipient.address);
                    }
                });
            }            
        }

        // Set up email parameters based on action type
        if (actionType === 'reply' || actionType === 'replyAll') {  
            subject = 'Re: ' + this.model.get('subject');

            // Quote the original message
            content = '<br><br><br><b>';
            content += DateUtils.toMDYHHMMFormat(this.model.get('sentDate'));
            content += ' <' + (this.model.get('from')[0].address) + '> wrote:<br><br></b>';

            if(this.model.get('content') !== '')
                content += this.model.get('content');
            else
                content += this.model.get('contentText');
        }
        
        if (actionType === 'forward') {             
            subject = 'Fwd: ' + this.model.get('subject');

            // Include original message with headers
            content = '<br><br><br>';
            content += '---------- Forwarded message ---------<br>';
            content += 'From: ' + (this.model.get('from')[0].personal || '') + ' &#60;' + this.model.get('from')[0].address + '&#62;<br>';
            content += 'Date: ' + DateUtils.toMDYHHMMFormat(this.model.get('sentDate')) + '<br>';
            content += 'Subject: ' + this.model.get('subject') + '<br>';

            // Add To recipients
            if (this.model.get('to') && this.model.get('to').length > 0) {
                content += 'To: ';
                var toList = [];
                _.each(this.model.get('to'), function(recipient) {
                    toList.push((recipient.personal || '') + ' <' + recipient.address + '>');
                });
                content += toList.join('; ') + '<br>';
            }

            // Add CC recipients if any
            if (this.model.get('cc') && this.model.get('cc').length > 0) {
                content += 'Cc: ';
                var ccList = [];
                _.each(this.model.get('cc'), function(recipient) {
                    ccList.push((recipient.personal || '') + ' <' + recipient.address + '>');
                });
                content += ccList.join('; ') + '<br>';
            }

            content += '<br><br>';

            if(this.model.get('content') !== '')
                content += this.model.get('content');
            else
                content += this.model.get('contentText');
        }

        if (toAddresses.length === 0 && (actionType === 'reply' || actionType === 'replyAll')) 
            return null;

        var pois = [];
        if(this.model.get('purchaseOrders')) {
            _.each(this.model.get('purchaseOrders'), function (po) {
                pois.push(po.purchaseOrderId);
            });
        }      
          
        var to = null;
        var cc = null;
        var bcc = null;

        if (toAddresses.length > 0)
            to = toAddresses.join('; ');
            
        if (ccAddresses.length > 0)
            cc = ccAddresses.join('; ');

        if (bccAddresses.length > 0)
            bcc = bccAddresses.join('; ');

        return {
            from: from,
            to: to,
            cc: cc,
            bcc: bcc,
            content: content,
            subject: subject,
            allowFromSelection: true,
            title: '',
            id: 'new-mail',
            templateType: 'MAIL_SIGN',
            fetchTemplateData: _.bind(function () {
                var defer = $.Deferred();
                defer.resolve({
                    customer: {},
                    pois: pois
                });
                return defer.promise();
            }, this),
            templateLocale: Settings.get('lang'),
            linkedEmail: this.model,
            // Pass the action through so the EmailView knows when to thread the
            // reply (reply / replyAll → include the linked email's Gmail threadId
            // so the message lands in the same conversation). Forwards stay as
            // new threads by default.
            actionType: actionType
        };
    },

      onReply: function() {
          var emailParams = this.prepareEmailAction('reply');
          if (emailParams) {
              EmailView.prototype.open(emailParams);
          }
      },

      onReplyAll: function() {
          var emailParams = this.prepareEmailAction('replyAll');
          if (emailParams) {
              EmailView.prototype.open(emailParams);
          }
      },

      onForward: function() {
          var emailParams = this.prepareEmailAction('forward');
          if (emailParams) {
              EmailView.prototype.open(emailParams);
          }
      }

  });
});

